import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import SbEditable from 'storyblok-react'

const PconUiToolBlock = ({ block }) => {
  const { t } = useTranslation()

  const [customPconState, setCustomPconState] = useState(false)

  useEffect(() => {
    if (location.hash === '#custom_pcon_iframe') {
      setCustomPconState(true)
    }

    if (window) {
      window.addEventListener('message', receivePconFrameMessage, false);
      let wrapper = document.querySelector("[data-init='pcon-order-form']")
      if (wrapper) {
        wrapper.dataset.isPconOriginal = true
      }
    }
    // todo remove event listener
    return function cleanup() {
      window.removeEventListener('message', receivePconFrameMessage)
    }
  }, [])

  const receivePconFrameMessage = (event) => {
    if (event.origin && event.origin.indexOf('https://ui.pcon-solutions.com') !== -1 && event.data?.action === "contact-request") {
      let wrapper = document.querySelector("[data-init='pcon-order-form'][data-is-pcon-original='true']")
      let oldNode = document.querySelector("[data-init='pcon-order-form'][data-is-pcon-original='false']")
      if (oldNode) {
        oldNode.remove()
      }
      wrapper.dataset.isPconOriginal = false
      wrapper.after(wrapper.cloneNode(true))
      wrapper.dataset.isPconOriginal = true
      wrapper = document.querySelector("[data-init='pcon-order-form'][data-is-pcon-original='false']")
      let scrTagString = wrapper.innerHTML
      let formBuilderParamName = wrapper.dataset.formBuilderParamName
      var paramVal = 'obx=' + encodeURIComponent(event.data.data.obxUrl);

      scrTagString = '<script type="text/javascript" defer data-role="form" src="https://form.123formbuilder.com/embed/4876518.js?type=lightbox" data-default-width="730px" data-embed-type="lightbox-text-link" data-embed-text-link="X" data-custom-vars="' + formBuilderParamName + '=' + paramVal + '"></script><span></span>'
      const slotHtml = document.createRange().createContextualFragment(scrTagString) // Create a 'tiny' document and parse the html string
      wrapper.innerHTML = ""
      wrapper.appendChild(slotHtml) // Append the new content
      let embed = document.querySelector("[data-init='pcon-order-form'][data-is-pcon-original='false']").querySelector("script")

      embed.onload = function () {
        wrapper.style.visibility = "hidden"
        wrapper.querySelectorAll('a')[0].click();
      }
    }
  }

  const pconCustomHandler = () => {
    location.hash = '#custom_pcon_iframe'
    setCustomPconState(true)
  }

  const reloadHandler = () => {
    location.reload()
  }

  return (
    <>
      <SbEditable content={block}>
        <section className="pt-0 pcon-ui-tool-block">
          <div className="pcon-ui-tool-block-container">
            <h3 className="pcon-ui-tool-block-headline">
              {t('product_page.pcon_ui_tool_block.title')}
            </h3>
            <div className="richtext">
              <p
                dangerouslySetInnerHTML={{
                  __html: t('product_page.pcon_ui_tool_block.description'),
                }}
              />
              {block.custom_pcon_ui_tool_url?.length > 0 && (
                <>
                  {customPconState === false ? (
                    <p id="custom_pcon_iframe_link">
                      {t(
                        'product_page.pcon_ui_tool_block.custom_iframe_description'
                      )}{' '}
                      <button onClick={() => pconCustomHandler()}>
                        {t(
                          'product_page.pcon_ui_tool_block.custom_iframe_link'
                        )}
                      </button>
                    </p>
                  ) : (
                    <p id="custom_pcon_iframe_link">
                      {t(
                        'product_page.pcon_ui_tool_block.custom_iframe_description'
                      )}{' '}
                      <button onClick={() => location.reload()}>
                        {t(
                          'product_page.pcon_ui_tool_block.custom_iframe_link'
                        )}
                      </button>
                    </p>
                  )}
                </>
              )}
            </div>
            {block.custom_pcon_ui_tool_url?.length > 0 && (
              <iframe
                style={{
                  width: '100%',
                  maxWidth: '71.25rem',
                  border: '1px solid #dadada',
                  overflow: 'hidden',
                  display: customPconState === false ? 'none' : 'block',
                }}
                src={block.custom_pcon_ui_tool_url}
                width="100%"
                height="900"
                frameBorder="0"
              ></iframe>
            )}
            <iframe
              style={{
                width: '100%',
                maxWidth: '71.25rem',
                border: '1px solid #dadada',
                overflow: 'hidden',
                display: customPconState === true ? 'none' : 'block',
              }}
              src={block.pcon_ui_tool_url}
              width="100%"
              height="900"
              frameBorder="0"
            ></iframe>
          </div>
        </section>

        <div
          data-init="pcon-order-form"
          data-pcon-get-param-name="pcon_product_param"
          data-form-builder-param-name="control54371746"
        >
        </div>
      </SbEditable>
    </>
  )
}

export default PconUiToolBlock
